import React from "react";

function Default() {
  return <div className="content"><p>This page doesn't exist</p></div>;
}

export default Default;
